/** Session authentifiée : uniquement après GET /auth/session réussi. */
export function isAuthenticatedUser(
  user: { id?: string } | null | undefined,
  sessionHydrated?: boolean
): boolean {
  return Boolean(sessionHydrated && user?.id)
}
